import React from "react";
import { Table } from "antd";

export default function MetricsTable({ data, loading }) {
  const columns = [
    {
      title: "Data",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Page Views",
      dataIndex: "pageViews",
      key: "pageViews",
    },
    {
      title: "Visitantes Únicos",
      dataIndex: "uniqueVisitors",
      key: "uniqueVisitors",
    },
    {
      title: "Sessões",
      dataIndex: "sessions",
      key: "sessions",
    },
    {
      title: "Cliques WhatsApp",
      dataIndex: "whatsappClicks",
      key: "whatsappClicks",
    },
    {
      title: "Tempo Médio (s)",
      dataIndex: "avgTimeOnSite",
      key: "avgTimeOnSite",
    },
    {
      title: "CTR WhatsApp (%)",
      dataIndex: "whatsappCtr",
      key: "whatsappCtr",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={false}
      scroll={{ x: 900 }}
    />
  );
}